// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"ca2180be7707b5e3e388","293":"d75bc3c4fdddabfa8b4c"}[chunkId] + ".js";
};